import {
  AttendRegisterEntity,
} from './attendRegisterEntity';
import { AttendDateTime } from './valueObjects/attendDateTime';
import { LeaveDateTime } from './valueObjects/leaveDateTime';
import { NurseryId } from './valueObjects/nurseryId';
import { RegisterId } from './valueObjects/registerId';

import type {
  AttendRegisterJsonPub,
  AttendRegisterJsonPvt,
  AttendRegisterPropsPub,
  AttendRegisterPropsPvt,
} from './attendRegisterEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';

import { FactoryPub } from '@/domain/factoryPub';

export class AttendRegisterFactory extends FactoryPub<
  AttendRegisterEntity,
  AttendRegisterPropsPvt,
  AttendRegisterJsonPvt,
  AttendRegisterPropsPub,
  AttendRegisterJsonPub
> {
  comparePub = (
    a: EntityDataPubType<AttendRegisterJsonPvt, AttendRegisterJsonPub>,
    b: EntityDataPubType<AttendRegisterJsonPvt, AttendRegisterJsonPub>,
  ) => {
    const da = new Date(a.data.attendDateTime);
    const db = new Date(b.data.attendDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: AttendRegisterPropsPvt,
    propsPub: EntityPubNotNullType<AttendRegisterPropsPub>,
  ): AttendRegisterEntity {
    return new AttendRegisterEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<AttendRegisterJsonPvt, AttendRegisterJsonPub>,
  ): AttendRegisterEntity {
    return this.create({
      nurseryId: NurseryId.create(props.data.nurseryId),
      registerId: RegisterId.create(props.data.registerId),
      attendDateTime: AttendDateTime.create(new Date(props.data.attendDateTime)),
      leaveDateTime:
        props.data.leaveDateTime
          ? LeaveDateTime.create(new Date(props.data.leaveDateTime))
          : undefined,
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
